module.exports = __webpack_public_path__ + "assets/alert.b9ab896c.svg";